/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiCreateUserVoipTokenRequestFromJSON(json) {
    return StreemApiCreateUserVoipTokenRequestFromJSONTyped(json, false);
}
export function StreemApiCreateUserVoipTokenRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'deviceSid': !exists(json, 'device_sid') ? undefined : json['device_sid'],
        'token': !exists(json, 'token') ? undefined : json['token'],
    };
}
export function StreemApiCreateUserVoipTokenRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'device_sid': value.deviceSid,
        'token': value.token,
    };
}
//# sourceMappingURL=StreemApiCreateUserVoipTokenRequest.js.map